export default __webpack_public_path__ + "59d6a9d1a28b3afc55f3bc43def38287.png";